import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SuspenseContent from "./containers/SuspenseContent";
import { setupImageDebugger } from "./TasteWeaverDebugger";

// デバッグツールの初期化 - デバッグモードの場合のみ
if (process.env.NODE_ENV === 'development' && window.location.search.includes('debug=true')) {
  console.log('デバッグモードが有効です - デバッグツールを初期化します');
  setupImageDebugger();
} else {
  console.log('通常モードで実行中 - デバッグツールは無効です');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<SuspenseContent />}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
